import React from 'react';
import { Deadline } from '../types';

interface UpcomingDeadlinesProps {
  deadlines: Deadline[];
}

const UpcomingDeadlines: React.FC<UpcomingDeadlinesProps> = ({ deadlines }) => {
  return (
    <div className="deadlines-card">
      <div className="card-header">
        <h2 className="card-title">Upcoming Deadlines</h2>
        <a href="#" className="view-all-link">View All</a>
      </div>

      <div className="deadlines-list">
        {deadlines.map((deadline, index) => (
          <div
            key={index}
            className={`deadline-item ${deadline.urgent ? 'deadline-urgent' : 'deadline-normal'}`}
          >
            <div className={`deadline-date-box ${deadline.urgent ? 'bg-red-500' : 'bg-yellow-500'}`}>
              <span className="deadline-date">{deadline.date}</span>
              <span className="deadline-month">{deadline.month}</span>
            </div>
            <div className="deadline-content">
              <h3 className="deadline-title">{deadline.title}</h3>
              <p className="deadline-description">{deadline.description}</p>
              <div className="deadline-meta">
                <span className={`deadline-badge ${deadline.urgent ? 'badge-red' : 'badge-yellow'}`}>
                  {deadline.daysLeft} days left
                </span>
                <span className="deadline-completion">{deadline.completion}% Complete</span>
              </div>
            </div>
            <button className="deadline-continue-button">Continue</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpcomingDeadlines;